import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'

new factory.IAInit()
openMobileSubmenu()

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})

// Swiper sliders initialisation
document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        itemPerSlide: 1, // 2 items per view on desktop, 1 on mobile
        autoplay: 2000 // change slide every 2 seconds
    })
})

document.querySelectorAll('.swiper-container.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        fullwidth: true,
        paginationElement: '.swiper-pagination',
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 4
            }
        }
    })
})

if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}
if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}